import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { Skeleton } from "designV2/components/Skeleton";
import EditUserForm from "./EditUserForm";
import "./superPeople.css";

const GET_USER = gql`
  query getUserByAdmin($id: ID!) {
    getUserByAdmin(id: $id) {
      _id
      fullName
      email
      phoneNumber
      profileImageUrl
      birthDate
      gender
      state
      isVerified
      emailVerified
      phoneNumberVerified
      addresses {
        full
        zipCode
      }
      defaultAddress {
        full
        zipCode
      }
    }
  }
`;

const EditUser = (props) => {
  const { loading, error, data } = useQuery(GET_USER, {
    variables: { id: props.match.params.id },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page superPeoplePage">
        <main className="main">
          <PageHeader title="Edit customer" />
          <Skeleton height={280} />
          <Skeleton height={180} />
        </main>
      </div>
    );
  }

  if (error || !data || !data.getUserByAdmin) {
    return <ErrorPage />;
  }

  return <EditUserForm user={data.getUserByAdmin} />;
};

export default EditUser;
